import React from "react";
import SettingsDialogOriginal from "../../../components/SettingsDialog";

interface SettingsDialogProps {
  open: boolean;
  onClose: () => void;
}

const SettingsDialog: React.FC<SettingsDialogProps> = ({ open, onClose }) => {
  return <SettingsDialogOriginal open={open} onClose={onClose} />;
};

export default SettingsDialog; 